export const menuItems = [
  {
    icon: 'file-1',
    activeIcon: 'file-active',
    href: '/documents',
    text: 'Documents',
    premiumRequired: false
  },
  {
    icon: 'template',
    activeIcon: 'template-active',
    href: '/templates',
    text: 'Templates',
    premiumRequired: false
  },
  {
    icon: 'archive-3',
    activeIcon: 'archive-active',
    href: '/documents/archive',
    text: 'Archive',
    premiumRequired: false
  },
  {
    icon: 'contacts',
    activeIcon: 'contacts-active',
    href: '/contacts',
    text: 'Contacts',
    premiumRequired: true,
    visible: organization => organization
  },
  {
    icon: 'grid',
    activeIcon: 'category',
    href: '/dashboard',
    text: 'My dashboard',
    spacer: true,
    premiumRequired: false,
    visible: organization => organization
  }
]
